const OPPREF_COOKIE = '__oppref';
const OPPREF_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export function buildOpprefCookie(value: string, hostname: string): string {
  const attributes = [
    `${OPPREF_COOKIE}=${encodeURIComponent(value)}`,
    `Max-Age=${OPPREF_MAX_AGE_SECONDS}`,
    'Path=/',
    'SameSite=Lax',
  ];

  if (hostname === 'tacostreetlocating.com' || hostname.endsWith('.tacostreetlocating.com')) {
    attributes.push('Domain=.tacostreetlocating.com', 'Secure');
  }

  return attributes.join('; ');
}

/**
 * The OpenAI click reference arrives on ai.tacostreetlocating.com, while the
 * completion pixel fires after involve.me redirects to tacostreetlocating.com.
 * Store the reference on the parent domain so both Taco Street hosts share the
 * same 30-day first-party attribution cookie across that redirect.
 */
export function captureOpenAIAdsAttribution(): void {
  if (typeof window === 'undefined') return;

  const oppref = new URLSearchParams(window.location.search).get('oppref')?.trim();
  if (!oppref) return;

  document.cookie = buildOpprefCookie(oppref, window.location.hostname);
}

/**
 * Record a confirmed lead with the OpenAI Ads pixel. The bootstrap snippet
 * installs a queueing function before the SDK finishes loading, so this is
 * safe to call as soon as the backend returns a successful lead ID.
 */
export function measureOpenAILead(eventId: string): boolean {
  if (typeof window === 'undefined') return false;

  const oaiq = (window as Window & {
    oaiq?: (...args: unknown[]) => void;
  }).oaiq;
  if (typeof oaiq !== 'function') return false;

  oaiq(
    'measure',
    'lead_created',
    { type: 'customer_action' },
    { event_id: eventId },
  );
  return true;
}
